import Faker from 'faker'
window.Faker = Faker

Faker.random.gender = function(){
  if (Faker.random.boolean()) {
    return 'female'
  }
  return 'male'
}

Faker.coupon = {
  code() {
    return [Faker.lorem.word().toUpperCase(), Faker.random.number(999)].join('-')
  }
}

Faker.address.cityWithZipCode = function(){
  return [Faker.address.zipCode('#####'), Faker.address.city()].join(' ')
}

const CAR_TYPES = ['mini_car', 'compact_car', 'limousine', 'station_wagon', 'transporter', 'van', 'suv', 'convertible', 'vintage_car', 'sportscar', 'recreational_vehicle', 'other']
Faker.car = {
  license() {
    return [
      Faker.lorem.word().slice(0, 2).toUpperCase(),
      "-",
      Faker.lorem.word().slice(0, 3).toUpperCase(),
      " ",
      Faker.random.number(999)
    ].join('')
  },

  carType() {
    return Faker.random.arrayElement(CAR_TYPES)
  }
}

Faker.birthday = {
  under18YearsBirthday() {
    return Faker.date.past(17).toISOString().slice(0, 10)
  },

  above18YearsBirthday() {
    return new Date(Faker.date.past(30) - (18*365*24*3600*1000)).toISOString().slice(0, 10)
  }
}


let FakeParams = {
  // recursively scan params and apply Faker data
  // https://github.com/marak/Faker.js/

  // Example:
  // a = {"foo": {"bar": "Faker.name.firstName"}, "baz": "Faker.name.lastName"}
  // FakerParams.apply(a)
  // => {"foo": {"bar": "Will"}, "baz": "Smith"}
  apply(originalParams) {
    let params = Object.assign({}, originalParams)
    for(let key in params) {
      if (Array.isArray(params[key])) {
        params[key] = params[key].map((item)=>{
          return this.apply({value: item}).value
        })
      } else if (typeof params[key] == 'object') {
        params[key] = this.apply(params[key])
      } else if(typeof params[key] == 'string' && params[key].slice(0, 6) == 'Faker.') {
        let parts = params[key].split('.')
        parts.shift()
        let result = Faker
        for (let part of parts) {
          if (part.slice(-2) == "()") {
            part = part.slice(0, -2)
          }
          if (typeof result[part] == "function") {
            if (part == 'email') {
              result = result[part](null, null, 'flipcar.de')
            } else {
              result = result[part]()
            }
            if (result.toISOString) {
              result = result.toISOString().slice(0,10)
            }
          } else {
            result = result[part]
          }
        }
        params[key] = result
      }
    }
    return params
  }

}

window.FakeParams = FakeParams
export default FakeParams